export const toMimecastInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  contentTypes,
  mimecastThrottleEnabled,
  pollingInterval
}) => {
  var _a;
  return {
    name: mimecastName == null ? void 0 : mimecastName.value,
    client_id: clientId == null ? void 0 : clientId.value,
    client_secret: clientSecret == null ? void 0 : clientSecret.value,
    content_type: (_a = contentTypes == null ? void 0 : contentTypes.value) == null ? void 0 : _a.split(","),
    enable_throttling: !!(mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value),
    polling_interval: pollingInterval == null ? void 0 : pollingInterval.value,
    polling_time_unit: "MINUTES"
  };
};
export const toGenericInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  mimecastThrottleEnabled,
  pollingInterval,
  contentTypes
}) => ({
  type: "org.graylog.enterprise.integrations.mimecastv2.MimecastV2Input",
  title: mimecastName.value,
  global: false,
  configuration: {
    client_id: clientId == null ? void 0 : clientId.value,
    client_secret: clientSecret == null ? void 0 : clientSecret.value,
    content_type: contentTypes.value.split(","),
    throttling_allowed: !!(mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value),
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES"
  }
});
